import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { omitBy } from 'lodash';

const sanitize = (search: any) => omitBy(search, (s) => !s || s === 'any');

const fromEntries = (entries: string[][]) =>
  entries.reduce(
    (newObject, [key, value]) => ({
      ...newObject,
      [key]: value,
    }),
    {},
  );

const entries = fromEntries(Array.from(new URLSearchParams(window.location.search)));

export default function useURLSearchParams() {
  const routeQuery = useSelector((state: any) => state.getIn(['route', 'locationBeforeTransitions', 'query']));

  const urlSearchParams = useMemo(() => {
    if (routeQuery) {
      return sanitize(routeQuery.toJS());
    }
    return sanitize(entries);
  }, [routeQuery]);

  return urlSearchParams;
}
